var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-desc",staticStyle:{"margin":"0 20px"}},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.onClickSave}},[_vm._v(_vm._s(_vm.leftTitle))]),(_vm.showRight)?_c('a-button',{on:{"click":_vm.onClickCancel}},[_vm._v(_vm._s(_vm.rightTitle))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }